module.exports = __webpack_public_path__ + "media/images/stats_demo-654acda495b3485cab89cb824dbed225.png";